import { Grid, TextField, Button, Snackbar, Alert } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useState } from "react";
import { BoxContainer } from "../Components";
import { COLORS } from "../GLOBAL";
import { BsSendArrowUpFill } from "react-icons/bs";
import emailjs from "@emailjs/browser";

const ContactScreen = () => {
  const [currentSvg, setCurrentSvg] = useState(0);
  const controls = useAnimation();
  const SVGs = [
    <svg
      enable-background="new 0 0 128 128"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="75%"
      key={0}
    >
      <linearGradient id="a">
        <stop offset="0" stop-color="#f9ddbd" />
        <stop offset=".3269" stop-color="#f8dbba" />
        <stop offset=".6038" stop-color="#f5d5af" />
        <stop offset=".8616" stop-color="#f0cb9e" />
        <stop offset="1" stop-color="#edc391" />
      </linearGradient>
      <radialGradient
        id="b"
        cx="26.457"
        cy="67.903"
        gradientTransform="matrix(1.0274 0 0 1.0036 10.486 3.4483)"
        gradientUnits="userSpaceOnUse"
        r="48.476"
        xlinkHref="#a"
      />
      <linearGradient
        id="c"
        gradientUnits="userSpaceOnUse"
        x1="20.633"
        x2="104.68"
        y1="104.23"
        y2="104.23"
      >
        <stop offset="0" stop-color="#edc391" />
        <stop offset="1" stop-color="#edc391" />
      </linearGradient>
      <linearGradient
        id="d"
        gradientUnits="userSpaceOnUse"
        x1="67.412"
        x2="15.176"
        y1="18.589"
        y2="112.62"
      >
        <stop offset="0" stop-color="#64b5f6" />
        <stop offset="1" stop-color="#2196f3" />
      </linearGradient>
      <radialGradient
        id="e"
        cx="41.122"
        cy="77.608"
        gradientTransform="matrix(1.0356 0 0 1.0036 12.995 3.4483)"
        gradientUnits="userSpaceOnUse"
        r="35.227"
        xlinkHref="#a"
      />
      <clipPath id="f">
        <path d="m74.79 63.14c-2.06-.62-4.03-1.08-5.93-1.38-7.78-1.23-14.15.24-19.16 4.2-4.84 3.83-22.37 16.31-30.06 24.5-3.67 3.92-.25 8.33 2.94 10.32 6.25 3.92 12.5 3.61 26.08-4.63 6.94-4.21 11.39-.7 16.32 2.67 0 0 7.71 6.39 14.5 8.78 2.67.94 6.73.94 11.01.11-20.12-.34-28.01-39.39-28.01-39.39s-.01-4.12 12.31-5.18z" />
      </clipPath>
      <path
        d="m124 72.49c0-3-2.43-5.46-5.52-5.61-2.48-.12-8.65 1.45-12.14-.19-8.61-4.05-44.1-22.73-44.1-22.73-3.12-1.69-10.77-4.19-14.65-3.22l-28.3 11.28c-2.76.69-5 2.36-6.43 4.53-1.04 1.18-2.18 9.38-3.74 16.83s-3.47 12.38-3.47 12.38c-1.54 5.68 2.95 9.49 6.94 10.17s9.21-1.77 10.75-7.46l3.28-15.74c.53-2.56 2.64-4.52 5.28-4.91l9.97.36-3.51 17.95s17.76 22.73 42.87 28.12c9.21 1.98 17.78-3.78 24.38-4.19 3.05-.19 9.39.48 12.18 1.29 3.1.9 6.22-1.38 6.22-4.51v-34.35z"
        fill="url(#b)"
      />
      <path
        d="m87.7 115.75c-6.36-.12-16.11-3.73-22.81-6.67-4.95-2.17-10.58-2.39-15.69-.58l-5.13 1.81c-4.87 1.72-10.33.1-13.37-3.97l-10.07-13.47 84.05-.17s-1.54 23.35-16.98 23.05z"
        fill="url(#c)"
      />
      <path
        d="m40.57 72.75 15.02-24.84-.1 4.15c-.1 4.24 2.67 8.05 6.83 9.4z"
        fill="#e6b77e"
      />
      <path
        d="m23.62 110.95-17.18 12.7c-1.22.9-2.74-.07-2.39-1.53l4.73-19.74c.11-.45.29-.9.54-1.3l56.96-94.86c1.21-2.01 3.68-2.81 5.52-1.77l8.77 4.95c1.84 1.04 2.35 3.51 1.14 5.53l-56.86 94.65c-.31.54-.73 1.01-1.23 1.37z"
        fill="#1e88e5"
      />
      <path
        d="m49.64 43.52c3.41 0 8.81 1.79 11.21 3.09 1.45.76 35.64 18.76 44.22 22.79 1.49.7 3.33 1.04 5.63 1.04 1.76 0 3.48-.19 5-.36.99-.11 1.93-.21 2.5-.21h.14c1.49.07 2.66 1.22 2.66 2.61v34.35c0 1.03-.95 1.71-1.83 1.71-.18 0-.37-.03-.55-.08-2.92-.85-8.58-1.44-11.83-1.44-.5 0-.96.01-1.37.04-2.84.18-5.77 1.13-8.87 2.15l-.61.2c-.41.13-.79.36-1.11.65-1.94 1.8-4.18 2.68-6.83 2.68h-.24c-4.61-.09-12.71-2.49-21.67-6.42-3.1-1.36-6.39-2.05-9.79-2.05-2.77 0-5.5.47-8.1 1.39l-5.13 1.81c-.96.34-1.96.51-2.97.51-2.77 0-5.38-1.29-7-3.44l-1.36-1.81c-.57-.76-1.46-1.2-2.4-1.2-.1 0-.19 0-.29.01-.3.03-.6.04-.88.04-2.9 0-3.96-1.47-4.5-2.58-.77-1.55-.87-3.15-.29-4.73.23-.63.23-1.3.04-1.91.65-.08 1.27-.38 1.76-.87.7-.71 1.52-1.32 2.42-1.81.04-.02.07-.04.1-.06l13.6-8.09c.73-.44 1.25-1.16 1.41-2l2.11-10.77c.18-.93-.08-1.89-.72-2.59-.57-.63-1.38-.99-2.22-.99-.09 0-.19 0-.28.01l-8.56.81c-.05.01-.11.01-.16.02-3.81.56-6.9 3.4-7.75 7.09l-4.65 14.44c-.01.04-.03.09-.04.13-.05.2-.12.42-.22.68-.23.64-.24 1.31-.05 1.92-.63.08-1.23.36-1.71.83-1.24 1.21-2.95 1.93-4.56 1.93-.28 0-.56-.02-.82-.07-1.63-.28-3.23-1.3-4.07-2.62-.68-1.07-.86-2.31-.51-3.68.36-.96 2.09-5.74 3.54-12.67.5-2.4.95-4.8 1.38-7.13.62-3.35 1.39-7.51 1.86-8.56.02-.03.05-.07.07-.1 1.08-1.63 2.74-2.8 4.66-3.28.13-.03.26-.07.38-.12l28.08-11.2c.26-.04.64-.09 1.17-.09m0-3c-.75 0-1.44.07-2.04.22l-28.3 11.28c-2.76.69-5 2.36-6.43 4.53-1.04 1.18-2.18 9.38-3.74 16.83-1.56 7.46-3.47 12.37-3.47 12.37-1.54 5.68 2.95 9.49 6.94 10.17.43.07.87.11 1.32.11 2.27 0 4.74-.92 6.65-2.78-.8 2.22-.75 4.68.43 7.07 1.5 3.04 4.18 4.25 7.19 4.25.39 0 .78-.02 1.17-.06l1.36 1.81c2.23 2.98 5.76 4.65 9.4 4.65 1.33 0 2.67-.22 3.97-.68l5.13-1.81c2.3-.81 4.7-1.21 7.1-1.21 2.93 0 5.86.6 8.59 1.8 6.7 2.94 16.46 6.55 22.81 6.67h.29c3.72 0 6.62-1.39 8.87-3.48 3.17-1.03 6.11-2.04 8.74-2.21.35-.02.75-.03 1.19-.03 3.29 0 8.53.61 10.99 1.32.47.14.93.2 1.39.2 2.58 0 4.83-2.05 4.83-4.71v-34.34c0-3-2.43-5.46-5.52-5.61-.09 0-.19-.01-.28-.01-1.69 0-4.68.57-7.5.57-1.6 0-3.13-.18-4.35-.75-8.61-4.05-44.1-22.73-44.1-22.73-2.66-1.43-8.54-3.44-12.63-3.44zm-26.6 48.87c.11-.3.21-.6.3-.92l4.7-14.57c.53-2.56 2.64-4.52 5.28-4.91l8.55-.8-2.11 10.77-13.6 8.09c-1.18.65-2.23 1.44-3.12 2.34z"
        fill="#e6b77e"
      />
      <path
        d="m23.62 110.95-17.18 12.7c-1.22.9-2.74-.07-2.39-1.53l4.73-19.74c.11-.45.29-.9.54-1.3l56.96-94.86c1.21-2.01 3.68-2.81 5.52-1.77l8.77 4.95c1.84 1.04 2.35 3.51 1.14 5.53l-56.86 94.65c-.31.54-.73 1.01-1.23 1.37z"
        fill="url(#d)"
      />
      <path
        d="m70.04 7c.11 0 .21.02.29.07l8.77 4.95c.04.02.17.1.24.34.04.15.1.54-.2 1.03l-56.86 94.66c-.12.19-.27.37-.45.5l-13.91 10.28 3.77-15.75c.04-.16.1-.31.19-.46l56.98-94.85c.31-.53.82-.77 1.18-.77m0-3c-1.44 0-2.91.81-3.76 2.22l-56.97 94.85c-.25.41-.43.85-.54 1.3l-4.73 19.74c-.25 1.08.5 1.89 1.4 1.89.33 0 .68-.11 1-.35l17.18-12.7c.5-.37.92-.83 1.24-1.37l56.86-94.65c1.21-2.01.7-4.49-1.14-5.53l-8.77-4.95c-.55-.3-1.16-.45-1.77-.45z"
        fill="#424242"
        opacity=".2"
      />
      <path
        d="m78.69 64.46c-12.41-4.71-22.01-4.01-29 1.51-4.84 3.83-22.37 16.31-30.06 24.5-3.67 3.92-.25 8.33 2.94 10.32 6.25 3.92 12.5 3.61 26.08-4.63 6.94-4.21 11.39-.7 16.32 2.67 0 0 7.71 6.39 14.5 8.78s22.66-1.28 27.97-9.32c5.87-8.89-3.63-24.29-28.75-33.83z"
        fill="url(#e)"
      />
      <g clip-path="url(#f)">
        <path
          d="m63.72 64.34c2.32 0 4.84.32 7.52.95-2.64 14.23 1.87 28.66 12.39 40.02-1.56-.07-2.57-.32-3.17-.53-6.19-2.18-13.51-8.2-13.58-8.26s-.14-.11-.22-.17l-.68-.47c-3.32-2.29-6.76-4.66-11.22-4.66-2.54 0-5.05.77-7.67 2.36-7.56 4.58-12.7 6.63-16.67 6.63-2.15 0-4.09-.61-6.27-1.98-1.67-1.05-2.95-2.63-3.1-3.86-.06-.43-.02-1.04.76-1.87 5.83-6.22 17.78-15.19 24.92-20.54 2.08-1.56 3.73-2.8 4.81-3.65 3.41-2.67 7.39-3.97 12.18-3.97m0-3c-5.5 0-10.16 1.57-14.03 4.62-4.84 3.83-22.37 16.31-30.06 24.5-3.67 3.92-.25 8.33 2.94 10.32 2.47 1.55 4.94 2.44 7.86 2.44 4.47 0 10.01-2.08 18.22-7.06 2.27-1.38 4.27-1.93 6.12-1.93 3.79 0 6.89 2.33 10.2 4.6 0 0 7.71 6.39 14.5 8.78 1.38.48 3.12.72 5.08.72 1.84 0 3.86-.21 5.93-.61-12.97-11.05-20.03-27.57-15.69-44.58-4.01-1.21-7.69-1.8-11.07-1.8z"
          fill="#e6b77e"
        />
      </g>
    </svg>,
    <svg
      width="75%"
      viewBox="0 0 178 197"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={1}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118.027 123.781L102.296 138.218L103.001 138.215L102.859 138.344H78.8931L90.929 138.279L74.8462 138.2L58.9253 123.781H118.027ZM125.961 116.5L148.969 95.3842V36.4691C148.969 32.413 145.743 29.125 141.875 29.125H35.4685C31.5509 29.125 28.375 32.356 28.375 36.4214V96.1126L50.8857 116.5H125.961ZM64.4886 21.8438L88.6719 0L112.855 21.8438H141.893C149.743 21.8438 156.062 28.3624 156.062 36.4035V60.8712L177.344 80.0938V182.074C177.344 190.081 170.98 196.594 163.131 196.594H14.213C6.31176 196.594 0 190.093 0 182.074V80.0938L21.2812 60.8712V36.4035C21.2812 28.3054 27.625 21.8438 35.4505 21.8438H64.4886ZM102.347 21.8438L88.6719 9.46563L74.9963 21.8438H102.347ZM156.062 70.4626L166.703 80.0938L156.062 89.8021V70.4626ZM21.2812 89.8021L10.6406 80.0938L21.2812 70.4626V89.8021ZM67.3906 145.625L17.7344 189.312H159.609L109.953 145.625H67.3906ZM168.016 187.311L113.5 138.468L140.5 113.5L170.25 87.375V134.703V182.032C170.25 184.093 169.392 185.977 168.016 187.311ZM9.32729 187.311L63.8438 138.468L7.09375 87.375V134.703V182.032C7.09375 184.093 7.95213 185.977 9.32729 187.311ZM42.5625 50.9688V58.25H134.781V50.9688H42.5625ZM42.5625 72.8125V80.0938H134.781V72.8125H42.5625ZM42.5625 94.6562V101.938H134.781V94.6562H42.5625Z"
        fill="black"
      />
      <path
        d="M67.3906 145.625L17.7344 189.312H159.609L109.953 145.625H67.3906Z"
        fill="#FFBC0E"
      />
      <path
        d="M9.32729 187.311L63.8438 138.468L7.09375 87.375V134.703V182.032C7.09375 184.093 7.95213 185.977 9.32729 187.311Z"
        fill="#FFBC0E"
      />
      <path
        d="M118.027 123.781L102.296 138.218L103.001 138.215L102.859 138.344H78.8931L90.929 138.279L74.8462 138.2L58.9253 123.781H118.027Z"
        fill="#FFBC0E"
      />
      <path
        d="M21.2812 89.8021L10.6406 80.0938L21.2812 70.4626V89.8021Z"
        fill="#FFBC0E"
      />
      <path
        d="M156.062 70.4626L166.703 80.0938L156.062 89.8021V70.4626Z"
        fill="#FFBC0E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M125.961 116.5L148.969 95.3842V36.4691C148.969 32.413 145.743 29.125 141.875 29.125H35.4685C31.5509 29.125 28.375 32.356 28.375 36.4214V96.1126L50.8857 116.5H125.961ZM42.5625 58.25V50.9688H134.781V58.25H42.5625ZM42.5625 80.0938V72.8125H134.781V80.0938H42.5625ZM42.5625 101.938V94.6562H134.781V101.938H42.5625Z"
        fill="white"
      />
      <path
        d="M168.016 187.311L113.5 138.468L140.5 113.5L170.25 87.375V134.703V182.032C170.25 184.093 169.392 185.977 168.016 187.311Z"
        fill="#FFBC0E"
      />
      <path
        d="M102.347 21.8438L88.6719 9.46563L74.9963 21.8438H102.347Z"
        fill="#FFBC0E"
      />
    </svg>,
    <svg
      key={2}
      width="75%"
      viewBox="0 0 226 210"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M213.971 1.95703L213.975 1.95566C215.407 1.46784 216.964 1.36879 218.458 1.67258C219.946 1.975 221.297 2.66121 222.359 3.63722C223.381 4.63589 224.066 5.86992 224.351 7.19102C224.636 8.51705 224.511 9.89196 223.985 11.1603L223.979 11.1741L223.974 11.188L148.553 203.678L148.552 203.681C148.021 205.044 147.05 206.245 145.747 207.113C144.446 207.979 142.882 208.467 141.26 208.5C139.654 208.499 138.092 208.051 136.778 207.224C135.461 206.396 134.46 205.232 133.887 203.896L133.886 203.893L101.874 129.708L161.152 74.694L162.336 73.5945L161.152 72.495L147.859 60.1582L146.837 59.2097L145.816 60.1598L86.7217 115.177L6.60536 85.4873L6.59382 85.483L6.5822 85.4789C5.06284 84.9441 3.77321 83.9993 2.87234 82.788C1.97278 81.5784 1.5 80.1572 1.5 78.713C1.5 77.2688 1.97278 75.8476 2.87234 74.638C3.77143 73.4291 5.05775 72.4856 6.57322 71.9502C6.57621 71.9492 6.5792 71.9481 6.5822 71.9471L213.971 1.95703Z"
        fill="#7A859C"
        stroke="#3A92FA"
        stroke-width="3"
      />
    </svg>,
    <svg
      key={3}
      width="65%"
      viewBox="0 0 166 235"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M135.622 4.69849H13.0871C6.53537 4.69849 1.22412 10.0624 1.22412 16.6791V221.734C1.22412 228.35 6.53537 233.714 13.0871 233.714H135.622C142.174 233.714 147.485 228.35 147.485 221.734V16.6791C147.485 10.0624 142.174 4.69849 135.622 4.69849Z"
        fill="#68E1FD"
      />
      <path
        d="M135.61 235H13.0872C9.61729 234.997 6.29038 233.603 3.83675 231.125C1.38312 228.647 0.00324144 225.287 0 221.783V16.6789C0.00324144 13.1745 1.38312 9.81464 3.83675 7.33669C6.29038 4.85874 9.61729 3.46519 13.0872 3.46191H135.61C139.082 3.46191 142.412 4.85402 144.869 7.33232C147.325 9.81063 148.707 13.1724 148.71 16.6789V221.721C148.716 223.463 148.382 225.188 147.727 226.799C147.071 228.41 146.107 229.874 144.89 231.108C143.673 232.341 142.227 233.32 140.635 233.988C139.042 234.656 137.335 235 135.61 235ZM13.0872 5.93469C10.2667 5.93796 7.56255 7.07098 5.56811 9.0852C3.57366 11.0994 2.45174 13.8303 2.4485 16.6789V221.721C2.45174 224.57 3.57366 227.301 5.56811 229.315C7.56255 231.329 10.2667 232.462 13.0872 232.465H135.61C138.433 232.465 141.14 231.334 143.137 229.319C145.134 227.305 146.258 224.572 146.261 221.721V16.6789C146.258 13.8282 145.134 11.0954 143.137 9.08084C141.14 7.06627 138.433 5.93468 135.61 5.93469H13.0872Z"
        fill="#093F68"
      />
      <path
        d="M134.325 27.8186H14.3852C10.9572 27.8186 8.17822 30.6251 8.17822 34.0871V200.653C8.17822 204.115 10.9572 206.921 14.3852 206.921H134.325C137.753 206.921 140.532 204.115 140.532 200.653V34.0871C140.532 30.6251 137.753 27.8186 134.325 27.8186Z"
        fill="white"
      />
      <path
        d="M134.386 208.146H14.4097C12.441 208.146 10.5527 207.357 9.1594 205.952C7.76613 204.547 6.98176 202.641 6.97852 200.653V34.0871C6.97852 32.0967 7.76144 30.1878 9.15507 28.7804C10.5487 27.373 12.4389 26.5823 14.4097 26.5823H134.386C136.341 26.6083 138.208 27.41 139.582 28.8143C140.957 30.2186 141.729 32.1126 141.732 34.0871V200.653C141.726 202.625 140.952 204.516 139.578 205.918C138.204 207.32 136.339 208.12 134.386 208.146ZM14.4097 29.055C13.0882 29.055 11.8209 29.5852 10.8864 30.5289C9.95198 31.4726 9.42702 32.7525 9.42702 34.0871V200.653C9.43026 201.986 9.95667 203.262 10.8908 204.203C11.8248 205.144 13.0904 205.673 14.4097 205.673H134.386C135.706 205.673 136.971 205.144 137.905 204.203C138.839 203.262 139.366 201.986 139.369 200.653V34.0871C139.369 32.7525 138.844 31.4726 137.91 30.5289C136.975 29.5852 135.708 29.055 134.386 29.055H14.4097Z"
        fill="#093F68"
      />
      <path
        d="M55.4831 19.3741C56.5378 19.3741 57.3929 18.5106 57.3929 17.4454C57.3929 16.3801 56.5378 15.5166 55.4831 15.5166C54.4283 15.5166 53.5732 16.3801 53.5732 17.4454C53.5732 18.5106 54.4283 19.3741 55.4831 19.3741Z"
        fill="#093F68"
      />
      <path
        d="M95.1365 18.6324H64.6036C64.279 18.6324 63.9676 18.5022 63.738 18.2703C63.5084 18.0384 63.3794 17.724 63.3794 17.3961C63.3794 17.0681 63.5084 16.7537 63.738 16.5218C63.9676 16.2899 64.279 16.1597 64.6036 16.1597H95.1365C95.4612 16.1597 95.7726 16.2899 96.0022 16.5218C96.2317 16.7537 96.3607 17.0681 96.3607 17.3961C96.3607 17.724 96.2317 18.0384 96.0022 18.2703C95.7726 18.5022 95.4612 18.6324 95.1365 18.6324Z"
        fill="#093F68"
      />
      <path
        d="M74.349 227.705C78.7912 227.705 82.3923 224.069 82.3923 219.582C82.3923 215.096 78.7912 211.459 74.349 211.459C69.9068 211.459 66.3057 215.096 66.3057 219.582C66.3057 224.069 69.9068 227.705 74.349 227.705Z"
        fill="#093F68"
      />
      <path
        d="M28.8433 161.658H119.866V102.855L74.3487 73.0706L28.8433 102.855V161.658Z"
        fill="#FFBC0E"
      />
      <path
        d="M119.866 162.894H28.8434C28.5187 162.894 28.2073 162.764 27.9777 162.532C27.7481 162.3 27.6191 161.985 27.6191 161.657V102.855C27.6195 102.648 27.6712 102.445 27.7696 102.263C27.868 102.082 28.0099 101.928 28.1823 101.816L73.6877 72.0318C73.8863 71.9014 74.1181 71.832 74.3549 71.832C74.5918 71.832 74.8236 71.9014 75.0222 72.0318L120.528 101.816C120.7 101.928 120.842 102.082 120.94 102.263C121.039 102.445 121.09 102.648 121.091 102.855V161.657C121.091 161.985 120.962 162.3 120.732 162.532C120.503 162.764 120.191 162.894 119.866 162.894ZM30.0676 160.421H118.642V103.547L74.3978 74.5417L30.1166 103.535L30.0676 160.421Z"
        fill="#093F68"
      />
      <path d="M35.6255 88.3892H113.084V157.8H35.6255V88.3892Z" fill="white" />
      <path
        d="M113.084 159.036H35.6256C35.3009 159.036 34.9895 158.906 34.7599 158.674C34.5303 158.442 34.4014 158.128 34.4014 157.8V88.3892C34.4014 88.0613 34.5303 87.7468 34.7599 87.515C34.9895 87.2831 35.3009 87.1528 35.6256 87.1528H113.084C113.409 87.1528 113.72 87.2831 113.95 87.515C114.179 87.7468 114.308 88.0613 114.308 88.3892V157.8C114.308 158.128 114.179 158.442 113.95 158.674C113.72 158.906 113.409 159.036 113.084 159.036ZM36.8499 156.564H111.86V89.6256H36.8499V156.564Z"
        fill="#093F68"
      />
      <path
        d="M101.478 102.929H47.2316C46.9069 102.929 46.5955 102.799 46.3659 102.567C46.1363 102.335 46.0073 102.021 46.0073 101.693C46.0073 101.365 46.1363 101.051 46.3659 100.819C46.5955 100.587 46.9069 100.457 47.2316 100.457H101.478C101.803 100.457 102.114 100.587 102.344 100.819C102.573 101.051 102.702 101.365 102.702 101.693C102.702 102.021 102.573 102.335 102.344 102.567C102.114 102.799 101.803 102.929 101.478 102.929Z"
        fill="#DFEAEF"
      />
      <path
        d="M101.478 112.684H47.2316C46.9069 112.684 46.5955 112.554 46.3659 112.322C46.1363 112.09 46.0073 111.776 46.0073 111.448C46.0073 111.12 46.1363 110.806 46.3659 110.574C46.5955 110.342 46.9069 110.212 47.2316 110.212H101.478C101.803 110.212 102.114 110.342 102.344 110.574C102.573 110.806 102.702 111.12 102.702 111.448C102.702 111.776 102.573 112.09 102.344 112.322C102.114 112.554 101.803 112.684 101.478 112.684Z"
        fill="#DFEAEF"
      />
      <path
        d="M101.478 122.489H47.2316C46.9069 122.489 46.5955 122.359 46.3659 122.127C46.1363 121.895 46.0073 121.58 46.0073 121.252C46.0073 120.925 46.1363 120.61 46.3659 120.378C46.5955 120.146 46.9069 120.016 47.2316 120.016H101.478C101.803 120.016 102.114 120.146 102.344 120.378C102.573 120.61 102.702 120.925 102.702 121.252C102.702 121.58 102.573 121.895 102.344 122.127C102.114 122.359 101.803 122.489 101.478 122.489Z"
        fill="#DFEAEF"
      />
      <path
        d="M101.478 132.182H47.2316C46.9069 132.182 46.5955 132.052 46.3659 131.82C46.1363 131.588 46.0073 131.274 46.0073 130.946C46.0073 130.618 46.1363 130.303 46.3659 130.071C46.5955 129.839 46.9069 129.709 47.2316 129.709H101.478C101.803 129.709 102.114 129.839 102.344 130.071C102.573 130.303 102.702 130.618 102.702 130.946C102.702 131.274 102.573 131.588 102.344 131.82C102.114 132.052 101.803 132.182 101.478 132.182Z"
        fill="#DFEAEF"
      />
      <path
        d="M119.866 161.658H28.8433V102.855L119.866 161.658Z"
        fill="#FFBC0E"
      />
      <path
        d="M119.866 162.894H28.8434C28.5187 162.894 28.2073 162.764 27.9777 162.532C27.7481 162.3 27.6191 161.985 27.6191 161.657V102.855C27.6195 102.633 27.6789 102.416 27.7912 102.225C27.9034 102.034 28.0644 101.878 28.2572 101.772C28.4499 101.665 28.6674 101.614 28.8869 101.621C29.1064 101.629 29.3197 101.697 29.5045 101.816L120.528 160.619C120.749 160.764 120.919 160.977 121.011 161.227C121.103 161.477 121.112 161.75 121.038 162.006C120.964 162.261 120.809 162.486 120.598 162.646C120.387 162.806 120.13 162.893 119.866 162.894ZM30.0676 160.421H115.68L30.0676 105.179V160.421Z"
        fill="#093F68"
      />
      <path
        d="M28.8433 161.658H119.866V102.855L28.8433 161.658Z"
        fill="#FFBC0E"
      />
      <path
        d="M119.866 162.894H28.8431C28.5791 162.893 28.3224 162.806 28.1113 162.646C27.9002 162.486 27.746 162.261 27.6716 162.006C27.5973 161.75 27.6068 161.477 27.6988 161.227C27.7908 160.977 27.9603 160.764 28.1821 160.619L119.205 101.816C119.39 101.697 119.603 101.629 119.823 101.621C120.042 101.614 120.26 101.665 120.452 101.772C120.645 101.878 120.806 102.034 120.918 102.225C121.031 102.416 121.09 102.633 121.09 102.855V161.657C121.09 161.985 120.962 162.3 120.732 162.532C120.502 162.764 120.191 162.894 119.866 162.894ZM33.0301 160.421H118.642V105.179L33.0301 160.421Z"
        fill="#093F68"
      />
      <path
        d="M119.866 162.894C119.633 162.897 119.404 162.833 119.205 162.709L73.6877 133.307C73.4133 133.13 73.2198 132.85 73.1498 132.529C73.0798 132.208 73.139 131.872 73.3143 131.595C73.4896 131.318 73.7668 131.122 74.0848 131.052C74.4028 130.981 74.7355 131.041 75.0099 131.218L120.528 160.619C120.8 160.796 120.992 161.076 121.06 161.396C121.129 161.715 121.07 162.05 120.895 162.325C120.784 162.499 120.632 162.643 120.452 162.742C120.273 162.841 120.071 162.894 119.866 162.894Z"
        fill="#093F68"
      />
      <path
        d="M136.419 1.38502C130.702 1.38084 125.119 3.12936 120.408 6.39927C115.697 9.66918 112.08 14.3064 110.035 19.6976C107.99 25.0887 107.614 30.9798 108.956 36.5915C110.299 42.2032 113.297 47.2711 117.553 51.1248V66.1346L125.939 56.3918C129.803 57.9529 133.962 58.6321 138.116 58.3809C142.271 58.1297 146.319 56.9542 149.972 54.9386C153.624 52.9231 156.79 50.1172 159.243 46.7217C161.697 43.3263 163.377 39.4252 164.163 35.2976C164.949 31.17 164.823 26.9179 163.792 22.8454C162.762 18.773 160.852 14.981 158.201 11.7406C155.55 8.50022 152.223 5.8916 148.457 4.10138C144.692 2.31116 140.581 1.38358 136.419 1.38502Z"
        fill="#F56132"
      />
      <path
        d="M117.552 67.3709C117.405 67.3723 117.259 67.3428 117.124 67.2843C116.892 67.1967 116.691 67.0398 116.549 66.8344C116.407 66.6291 116.33 66.385 116.328 66.1345V51.6688C110.967 46.6273 107.651 39.7539 107.026 32.3827C106.4 25.0115 108.508 17.6684 112.942 11.7788C117.375 5.88919 123.817 1.87326 131.017 0.510547C138.218 -0.85217 145.663 0.535539 151.907 4.4043C158.151 8.27307 162.749 14.3469 164.808 21.4468C166.868 28.5466 166.242 36.166 163.052 42.8259C159.862 49.4859 154.335 54.7112 147.545 57.4876C140.755 60.264 133.185 60.3934 126.306 57.8507L118.471 66.9382C118.357 67.0723 118.216 67.1803 118.058 67.255C117.9 67.3296 117.727 67.3691 117.552 67.3709ZM136.418 2.62135C130.951 2.62305 125.614 4.29938 121.11 7.42893C116.607 10.5585 113.149 14.994 111.194 20.1497C109.239 25.3055 108.879 30.9388 110.16 36.3058C111.442 41.6728 114.305 46.5209 118.373 50.2099C118.499 50.3255 118.601 50.4666 118.671 50.6241C118.74 50.7817 118.776 50.9522 118.777 51.1248V62.821L125.02 55.5758C125.187 55.3841 125.408 55.2492 125.654 55.1894C125.899 55.1296 126.157 55.148 126.392 55.2419C130.088 56.7362 134.067 57.3867 138.042 57.1469C142.017 56.9071 145.89 55.783 149.384 53.855C152.879 51.927 155.908 49.2428 158.256 45.9944C160.603 42.746 162.211 39.0138 162.963 35.0647C163.716 31.1157 163.594 27.0475 162.608 23.1513C161.622 19.2551 159.796 15.6271 157.259 12.5271C154.723 9.42698 151.539 6.93142 147.936 5.21896C144.333 3.5065 140.4 2.61947 136.418 2.62135Z"
        fill="#093F68"
      />
      <path
        d="M135.194 24.8142L131.338 28.239L129.036 25.556L135.304 20.2148H139.099V39.6508H135.194V24.8142Z"
        fill="white"
      />
      <path
        d="M51.7125 70.8451C51.4061 70.8464 51.1103 70.7315 50.8836 70.5232C50.6569 70.3149 50.5159 70.0283 50.4883 69.72L49.4477 57.6529C49.4205 57.3267 49.5226 57.003 49.7314 56.7527C49.9402 56.5023 50.2388 56.3459 50.5617 56.3176C50.8847 56.2902 51.2053 56.3932 51.4531 56.6041C51.701 56.815 51.8559 57.1166 51.8839 57.4427L52.9246 69.5098C52.9517 69.836 52.8497 70.1597 52.6408 70.41C52.432 70.6603 52.1334 70.8168 51.8105 70.8451H51.7125Z"
        fill="#DFEAEF"
      />
      <path
        d="M40.6822 74.2698C40.4742 74.2702 40.2695 74.2171 40.0874 74.1154C39.9053 74.0138 39.7519 73.8669 39.6416 73.6887L31.5493 60.6696C31.4644 60.5309 31.4074 60.3766 31.3818 60.2157C31.3561 60.0547 31.3622 59.8902 31.3998 59.7316C31.4373 59.573 31.5056 59.4235 31.6006 59.2916C31.6956 59.1598 31.8155 59.0482 31.9533 58.9634C32.2296 58.794 32.561 58.7419 32.8752 58.8183C33.1894 58.8948 33.4609 59.0936 33.6305 59.3714L41.6739 72.4523C41.7594 72.5903 41.817 72.7439 41.8436 72.9044C41.8702 73.0649 41.8651 73.2291 41.8287 73.3876C41.7924 73.5461 41.7253 73.6958 41.6315 73.8281C41.5377 73.9604 41.419 74.0727 41.2821 74.1586C41.0947 74.2462 40.8883 74.2844 40.6822 74.2698Z"
        fill="#DFEAEF"
      />
      <path
        d="M31.9774 81.8114C31.7577 81.8113 31.542 81.7515 31.3531 81.6383L21.6692 75.7778C21.4241 75.5978 21.2538 75.3323 21.1914 75.0328C21.1289 74.7333 21.1786 74.4211 21.3309 74.1565C21.4832 73.8919 21.7273 73.6937 22.016 73.6004C22.3046 73.5071 22.6173 73.5252 22.8935 73.6512L32.5773 79.5117C32.8089 79.6504 32.9887 79.8625 33.089 80.1149C33.1892 80.3673 33.2042 80.646 33.1317 80.9079C33.0592 81.1698 32.9032 81.4003 32.6879 81.5636C32.4726 81.727 32.21 81.814 31.9407 81.8114H31.9774Z"
        fill="#DFEAEF"
      />
    </svg>,
  ];

  useEffect(() => {
    const animateMorphing = async () => {
      await controls.start({ opacity: 0 });
      setCurrentSvg((prev) => (prev + 1) % SVGs.length);

      await controls.start({ opacity: 1 });
    };

    const animationInterval = setInterval(() => {
      animateMorphing();
    }, 1000);

    return () => clearInterval(animationInterval);
  }, [controls, SVGs]);

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [confirmationMessage, setConfirmationMessage] = useState("");

  //for snackbar
  const [open, setOpen] = React.useState(false);
  const handleSubmit = () => {
    const serviceId = "service_rkxwxxq";
    const templateId = "template_4s0yatq";
    const publicKey = "7dACKJdfzaCbET5UX";

    const templateParams = {
      subject: subject,
      from_name: name,
      from_email: email,
      message: message,
    };

    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        setConfirmationMessage(
          "Your message was sent successfully! I'll get back to you as soon as possible:)"
        );
        console.log("successful", response);
        setName("");
        setSubject("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        setConfirmationMessage(
          "Error sending your message, please try again:("
        );
        console.log("error", error);
      });
    setOpen(true);
  };

  const handleCLose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };
  const handleSubject = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSubject(event.target.value);
  };

  const handleMessage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(event.target.value);
  };

  return (
    <Grid
      container
      marginY={8}
      paddingX={4}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={6} sx={{ justifySelf: "center" }}>
        <div style={styles.container}>
          <motion.div animate={controls} initial={{ opacity: 1 }}>
            {SVGs[currentSvg]}
          </motion.div>
        </div>
      </Grid>
      <Grid item xs={6}>
        <BoxContainer bgcolor={COLORS.DodgerBlue}>
          <div style={styles.title}>Let's get in touch!</div>
          <TextField
            id="outlined-basic"
            label="Name"
            InputLabelProps={{ style: { color: COLORS.White } }}
            InputProps={{
              style: styles.text,
            }}
            sx={styles.textfield}
            value={name}
            onChange={handleName}
          />
          <TextField
            id="outlined-basic"
            label="Email"
            InputLabelProps={{ style: { color: COLORS.White } }}
            InputProps={{
              style: styles.text,
            }}
            sx={styles.textfield}
            value={email}
            onChange={handleEmail}
          ></TextField>
          <TextField
            id="outlined-basic"
            label="Subject"
            InputLabelProps={{ style: { color: COLORS.White } }}
            InputProps={{
              style: styles.text,
            }}
            sx={styles.textfield}
            value={subject}
            onChange={handleSubject}
          ></TextField>
          <TextField
            id="outlined-basic"
            label="Message"
            multiline
            rows={10}
            InputLabelProps={{ style: { color: COLORS.White } }}
            InputProps={{
              style: styles.text,
            }}
            sx={styles.textfield}
            value={message}
            onChange={handleMessage}
          ></TextField>
          <Button
            endIcon={<BsSendArrowUpFill />}
            variant="contained"
            sx={{
              background: COLORS.Orange,
              marginBottom: 2,
              "&:hover": { background: COLORS.Orange },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Snackbar open={open} autoHideDuration={3000} onClose={handleCLose}>
            <Alert severity="success" sx={{ width: "100%" }}>
              {confirmationMessage}
            </Alert>
          </Snackbar>
        </BoxContainer>
      </Grid>
    </Grid>
  );
};

const styles = {
  title: {
    color: COLORS.White,
    fontSize: "1.9vw",
    fontFamily: "JetBrains Mono",
    fontWeight: "700",
    marginTop: 20,
  },
  text: {
    color: COLORS.White,
    border: "1px solid transparent",
    borderRadius: 12,
    backgroundColor: COLORS.DarkBackground,
  },
  container: {
    height: "600px",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column" as const,
  },
  textfield: {
    margin: 4,
    width: "80%",
  },
};
export default ContactScreen;
